import React from 'react';

const QaFormTable = ({frontend, backend}) => {

  return (
    <div className='table_container iransans-b'>
      <table>
        <thead>
        <tr>
          <th colSpan={3}>FRONTEND DEVELOPER</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td className='number' rowSpan={"3"}>1</td>
          <td rowSpan={"2"} style={{height: "117px"}}>Insert : {frontend.insert}</td>
          <td style={{height: "58px"}}>Delete : {frontend.delete}</td>
        </tr>
        <tr>
          <td rowSpan={"2"} style={{height: "174px"}}>Validation : {frontend.validation}</td>
        </tr>
        <tr>
          <td rowSpan={"2"} style={{height: "115px"}}>Update : {frontend.update}</td>
        </tr>
        </tbody>
      </table>
      <table>
        <thead>
        <tr>
          <th colSpan={3}>BACKEND DEVELOPER</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td className='number' rowSpan={"3"}>2</td>
          <td rowSpan={"2"} style={{height: "117px"}}>Insert : {backend.insert}</td>
          <td style={{height: "58px"}}>Delete : {backend.delete}</td>
        </tr>
        <tr>
          <td rowSpan={"2"} style={{height: "174px"}}>Validation : {frontend.validation}</td>
        </tr>
        <tr>
          <td rowSpan={"2"} style={{height: "115px"}}>Update : {backend.update}</td>
        </tr>
        </tbody>
      </table>
    </div>
  );
};

export default QaFormTable;